import * as _ from 'lodash'

// this file makes assumptions, like that you want to use <draggable v-model>,
// and that the object order is captured via a 'sort_order' field.

// one day this helper might actually define the getter and setter for you on a parent class
// like SortableHelper.defineSortedProperty(BookmarkFolder, 'bookmark_links', 'sortedBookmarkLinks'), but that might be too indirect
export default {
  getSorted(unorderedArray) {
    return _.sortBy(unorderedArray, ['sort_order']);
  },

  setSorted(desiredArrayOrder) {
    desiredArrayOrder.forEach(function(item, index) {
      item.sort_order = index;
    })
  },
};
